import { useEffect } from 'react';
import { useRouter } from 'next/router';

// Types
import type { NotificationConversationsProps } from '@/utils/hooks/context/toast/types';

// Routes
import { MEDIA } from '@/routes/privateRoutes';

// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useSelectedSocialProfileById from '@/utils/hooks/socialprofiles/useSelectedSocialProfileById';

// Component
import Notification from '@/components/base/Notification';

const CommentPickerWinnerConfirmation = ({ notification }: NotificationConversationsProps) => {
    const router = useRouter();
    const { setActiveSocialProfile } = useActiveSocialProfile();
    const { selectedSocialProfile } = useSelectedSocialProfileById(
        notification?.data?.social_profile_id
    );
    const url = `${MEDIA.replace(
        '%mediaID%',
        notification?.data?.media_id.toString()
    )}?tab=comments`;
    const nbWinners = parseInt(notification?.data?.comments_picked_count.toString()) ?? 1;

    // Prefetch URL
    useEffect(() => {
        router.prefetch(url);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Notification
            dataNotification={notification}
            onClick={() => {
                if (selectedSocialProfile) {
                    setActiveSocialProfile(selectedSocialProfile);
                    router.push(url);
                }
            }}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="conversations" />
            <Notification.Content>
                <Notification.Title
                    i18nKey={
                        nbWinners === 1
                            ? 'commons:notifications.comment_picker_winner_confirmation.title'
                            : 'commons:notifications.comment_picker_winner_confirmation_multiple.title'
                    }
                />
                <Notification.Description
                    i18nKey={
                        nbWinners === 1
                            ? 'commons:notifications.comment_picker_winner_confirmation.description'
                            : 'commons:notifications.comment_picker_winner_confirmation_multiple.description'
                    }
                    values={{
                        username: notification?.data?.first_comment_user_name,
                        number: nbWinners - 1
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default CommentPickerWinnerConfirmation;
